/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { userControllerCreate } from "./userControllerCreate";
import { userControllerFindAll } from "./userControllerFindAll";
import { userControllerFindOne } from "./userControllerFindOne";
import { userControllerGetPermissions } from "./userControllerGetPermissions";
import { userControllerGetProfile } from "./userControllerGetProfile";
import { userControllerRemove } from "./userControllerRemove";
import { userControllerRevokeOwnSessions } from "./userControllerRevokeOwnSessions";
import { userControllerRevokeSessions } from "./userControllerRevokeSessions";
import { userControllerUpdate } from "./userControllerUpdate";
import { userControllerUpdateChangeOrderAccess } from "./userControllerUpdateChangeOrderAccess";

export function usersService() {
  return { userControllerCreate, userControllerFindAll, userControllerGetProfile, userControllerFindOne, userControllerUpdate, userControllerRemove, userControllerGetPermissions, userControllerUpdateChangeOrderAccess, userControllerRevokeOwnSessions, userControllerRevokeSessions }
}